import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { FileQueryParams, Result, ResultQueryParams } from '../models/result.model';
import { ResultGateway } from '../usecases/result.gateway';

@Injectable()
export class ResultService extends ResultGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listResults(params: ResultQueryParams): Observable<ListResponse<Result>> {
    const { projectId, unitId } = params;
    return this._http.get<ListResponse<Result>>(`api/vgs/projects/${projectId}/units/${unitId}/results`, { params });
  }

  getFile(params: FileQueryParams): Observable<{ url: string }> {
    const { projectId, unitId, resultId, fileId } = params;
    return this._http.get<{ url: string }>(`api/vgs/projects/${projectId}/units/${unitId}/results/${resultId}/files/${fileId}`);
  }
}
